export default __webpack_public_path__ + "static/media/juice-headline-desktop@2x.96c2ea7f.png";